import { OrderState } from '@/gen/publicApi'

import { cn } from '@/utils/cn'

import { StatusCircle } from '../statusCircle'
import { Tooltip, TooltipContent, TooltipTrigger } from '../tooltip'

interface Props {
    className?: string
    state: OrderState
}

const circles: Record<OrderState, JSX.Element> = {
    Filled: <StatusCircle variant="success" />,
    Expired: <StatusCircle variant="warning" />,
    Cancelled: <StatusCircle variant="warning" />,
    Open: <StatusCircle />,
    Pending: <StatusCircle variant="outline" />,
    Rejected: <StatusCircle variant="destructive" />,
}

export default function OrderStateCircle({ className, state }: Props) {
    const Cmp = circles[state]
    return (
        <Tooltip>
            <TooltipTrigger>
                <div className={cn(className)}>{Cmp}</div>
            </TooltipTrigger>
            <TooltipContent>{state}</TooltipContent>
        </Tooltip>
    )
}
